import type { LeadData } from '@/events/conversion';

import { BaseTracker } from './BaseTracker';
import type { TrackerFactory } from './TrackerFactory';

export class LeadTracker extends BaseTracker {
  constructor(factory: TrackerFactory) {
    super(factory);
  }

  track(data: LeadData): void {
    if (!this.factory.isManualEnabled('lead')) return;
    this.factory.dispatchManual('LEAD', data);
  }
}
